import React, { Component } from 'react';
import { Input, Button, Form, message } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styles from './style.less';
import { get, post } from '../../commons/http';
import { publicEncrypt } from 'crypto';
import GISBg from '../../components/gis-bg';
import supermapLogo from '../../assets/logos/supermap.png';
import hautLogo from '../../assets/logos/haut.png';

export default class ResetPwd extends Component {
  state = {
    loading: false,
    publicKey: '',
  };

  componentDidMount() {
    //获取公钥
    const getPublicKey = async () => {
      const response = await get('/user/key');
      const { data } = response;
      this.setState({ publicKey: data.key });
      window.localStorage.setItem('publicKey', data.key);
    };
    getPublicKey();
  }

  handleSubmit = async (values) => {
    if (this.state.loading) return;
    const { email, password, confirmPassword } = values;

    if (password !== confirmPassword) {
      message.error('两次输入的密码不一致', 1);
      return;
    }

    const rsaPassword = publicEncrypt(
      this.state.publicKey,
      Buffer.from(password)
    ).toString('base64');
    const response = await post('/user/resetPassword', {
      email,
      password: rsaPassword,
    });
    const { code, msg } = response;
    if (code === 0) {
      message.success('密码修改成功，请重新登录', 1);
      setTimeout(() => {
        this.props.history.replace('/login');
      }, 1000);
    } else {
      message.error(msg || '操作失败，请重试', 2);
    }
  };

  render() {
    const { loading } = this.state;

    return (
      <div className={styles.root}>
        <GISBg />
        <div className={styles['reset-card']}>
          <div className={styles['logo-row']}>
            <img
              src={supermapLogo}
              alt="超图"
              className={styles['logo-supermap']}
            />
            <span className={styles['logo-divider']} />
            <img
              src={hautLogo}
              alt="河南工业大学"
              className={styles['logo-haut']}
            />
          </div>
          <div className={styles.title}>超图杯 · 河南工业大学校赛报名系统</div>
          <div className={styles.subtitle}>找回密码</div>
          <Form name="resetPwd" onFinish={this.handleSubmit} size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱' },
                { type: 'email', message: '请输入正确的邮箱地址' },
              ]}
            >
              <Input
                allowClear
                autoFocus
                prefix={<MailOutlined />}
                placeholder="注册邮箱"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: '请输入新密码' },
                {
                  type: 'string',
                  min: 6,
                  message: '密码长度不能低于6位',
                },
                {
                  type: 'string',
                  max: 20,
                  message: '密码长度不能高于20位',
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="新密码"
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              rules={[
                { required: true, message: '请再次输入新密码' },
                {
                  type: 'string',
                  min: 6,
                  message: '密码长度不能低于6位',
                },
                {
                  type: 'string',
                  max: 20,
                  message: '密码长度不能高于20位',
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="确认新密码"
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 8 }}>
              <Button
                className={styles['submit-btn']}
                loading={loading}
                type="primary"
                htmlType="submit"
                block
              >
                重置密码
              </Button>
            </Form.Item>
          </Form>
          <div className={styles['to-login']}>
            <Link to="/login">返回登录</Link>
          </div>
        </div>
      </div>
    );
  }
}